module.exports = __webpack_public_path__ + "img/polymesh.c6d07367.svg";